<template>
  <fw-menu-popover :menu-items="menuItems" position="bottom-left" :menu-name="$T('Menu')">
    <template #trigger>
      <fw-tile-button data-focus="not-allow" :size="isPhoneSizeViewportWidth ? 'xlarge' : 'small'" icon-name="hamburger-list" />
    </template>
  </fw-menu-popover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { $T } from 'client/library/translation'
import type { MenuItem } from 'client/components/types'
import { useWindowResize } from 'client/composables/window-resize'
import { useWorkspaceStore } from 'app/services/pinia/workspace-store'
// import { useSheetBar } from 'client/pages/app/fragments/shared/editor-bottom-bar/sheet-bar'
import { useWorkbookActions } from 'client/composables/workbook-actions'
import { exportJpgAction, exportPDFAction, exportPngAction } from 'client/pages/integration-embed-editor/action/export-action'
import { useEmbedEvents } from 'client/pages/integration-embed-editor/composables/use-embed-events'
import { useEditorHelper } from '../../composables/use-editor-helper'

const { isPhoneSizeViewportWidth } = useWindowResize()
// const { newSheet } = useSheetBar()
const workbookActions = useWorkbookActions()

const isEditorLoaded = computed(() => useWorkspaceStore().editor?.mapStatus === 'loaded')
const canUndo = computed(() => Boolean(workbookActions.getAction('undo')?.isEnabled))
const canRedo = computed(() => Boolean(workbookActions.getAction('redo')?.isEnabled))
const workbook = computed(() => useWorkspaceStore().workbook)

// const handleNewSheet = () => {
//   if (!isEditorLoaded.value) return
//   newSheet()
// }

const handleUndo = () => {
  workbookActions.getAction('undo')?.execute?.()
}

const handleRedo = () => {
  workbookActions.getAction('redo')?.execute?.()
}

const handleExportPng = async () => {
  const blob = await exportPngAction()
  useEmbedEvents().emit('export-png', blob)
}

const handleExportJpeg = async () => {
  const blob = await exportJpgAction()
  useEmbedEvents().emit('export-jpeg', blob)
}

const handleExportPdf = async () => {
  const blob = await exportPDFAction()
  useEmbedEvents().emit('export-pdf', blob)
}

const menuItems = computed<MenuItem[]>(() => [
  {
    title: $T('File'),
    iconName: 'file',
    subMenuItems: [
      // {
      //   title: $T('New Sheet'),
      //   iconName: 'sheet-new',
      //   action: handleNewSheet,
      //   disabled: !isEditorLoaded.value,
      // },
      {
        title: $T('Download'),
        iconName: 'download',
        action: async () => {
          useEmbedEvents().emit('download-xmind-file', await useEditorHelper().downloadFile(workbook.value.document.value, workbook.value?.stage))
        },
        disabled: !isEditorLoaded.value,
      },
    ],
  },
  {
    title: $T('Edit'),
    iconName: 'edit',
    subMenuItems: [
      {
        title: $T('Undo'),
        iconName: 'undo',
        action: handleUndo,
        disabled: !isEditorLoaded.value || !canUndo.value,
      },
      {
        title: $T('Redo'),
        iconName: 'redo',
        action: handleRedo,
        disabled: !isEditorLoaded.value || !canRedo.value,
      },
    ],
  },
  {
    title: $T('Export As'),
    iconName: 'export',
    subMenuItems: [
      {
        title: 'PNG',
        action: handleExportPng,
        disabled: !isEditorLoaded.value,
      },
      {
        title: 'JPEG',
        action: handleExportJpeg,
        disabled: !isEditorLoaded.value,
      },
      {
        title: 'PDF',
        action: handleExportPdf,
        disabled: !isEditorLoaded.value,
      },
    ],
  },
])
</script>
